/**
 * Authentication API Service
 */

import { apiClient } from './client'
import type { LoginResponse, UserMe } from '@/types/api'

/**
 * Login with username and password
 */
export async function login(payload: { username: string; password: string }): Promise<LoginResponse> {
  return apiClient.post<LoginResponse>('/auth/login', payload)
}

/**
 * Logout (clears HttpOnly cookie)
 */
export async function logout(): Promise<{ message: string }> {
  return apiClient.post<{ message: string }>('/auth/logout')
}

/**
 * Get current authenticated user
 */
export async function getCurrentUser(): Promise<UserMe> {
  return apiClient.get<UserMe>('/auth/me')
}

export const authService = {
  login,
  logout,
  getCurrentUser,
}
